module.exports = __webpack_public_path__ + "img/squint.9843acb5.png";